import React, { Fragment, memo, useEffect, useState } from "react";
import { CCollapse } from "@coreui/react";
import { useDispatch, useSelector } from "react-redux";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import { toggleTags } from "../redux/revenueCategoriesSagas";

export const Info = memo(function Info({
  revenueCategoryId,
  showAllItems,
  canToggleTags,
  measure
}) {
  const dispatch = useDispatch();

  const info = useSelector((state) => state.revenueCategories.currentRevenueCategoryInfo);

  useEffect(() => {
    if (measure) measure();
  }, [info]);

  const [selectedCategories, setSelectedCategories] = useState([]);
  const [itemsToShow, setItemsToShow] = useState([]);

  const onToggleClick = (data) => {
    dispatch(toggleTags({ ...data, revenueCategoryId }));
  };

  const onItemClick = (id) => {
    if (showAllItems) return;
    setItemsToShow((prev) => {
      if (prev.includes(id)) {
        return prev.filter((prevId) => prevId !== id);
      } else {
        return [...prev, id];
      }
    });
  };

  const onChange = (e) => {
    let val = e.target.value;
    if (e.target.checked) {
      setSelectedCategories((prev) => [...prev, val]);
    } else {
      setSelectedCategories((prev) => prev.filter((v) => v !== val));
    }
  };

  const renderTags = ({ recurring, offer, offerRetention, membership, ...rest }) => {
    return (
      <div className="revenue-categories__tags">
        <button
          className={`button button--${recurring ? "primary" : "secondary"}`}
          onClick={() => onToggleClick({ recurring: !recurring, ...rest })}
        >
          Recurring
        </button>

        <button
          className={`button button--${offer ? "primary" : "secondary"}`}
          onClick={() => onToggleClick({ offer: !offer, ...rest })}
        >
          Intro Offer
        </button>

        <button
          className={`button button--${offerRetention ? "primary" : "secondary"}`}
          onClick={() => onToggleClick({ offerRetention: !offerRetention, ...rest })}
        >
          Using for Retention
        </button>

        <button
          className={`button button--${membership ? "primary" : "secondary"}`}
          onClick={() => onToggleClick({ membership: !membership, ...rest })}
        >
          Membership
        </button>
      </div>
    );
  };

  const renderMassToggles = () => {
    let data = { recurring: false, offer: false, offerRetention: false, membership: false };

    info.data.forEach(({ recurring, offer, offerRetention, membership }) => {
      data.recurring = recurring ? recurring : data.recurring;
      data.offer = offer ? offer : offer.offer;
      data.offerRetention = offerRetention ? offerRetention : data.offerRetention;
      data.membership = membership ? membership : data.membership;
    });

    return renderTags({ id: selectedCategories, ...data, mass_toggle: true });
  };

  return (
    <>
      <CCollapse show>
        <div className="revenue-categories__expanded">
          {info ? (
            <>
              {selectedCategories.length >= 2 && (
                <div className="revenue-categories__mass-toggle">{renderMassToggles()}</div>
              )}
              {info.data.map(({ id, productName, productId, ...rest }) => {
                return (
                  <Fragment key={id}>
                    <div className="revenue-categories__category">
                      {canToggleTags && (
                        <input
                          className="revenue-categories__checkbox"
                          type="checkbox"
                          value={id}
                          id={id}
                          onChange={onChange}
                          checked={selectedCategories.includes(id)}
                        />
                      )}

                      <div className="revenue-categories__product-id">{productId}</div>
                      <div key={id} className="revenue-categories__product-name">
                        {productName}
                      </div>

                      {canToggleTags && (
                        <>
                          <span
                            className="glyphicon glyphicon-tags gray tags-button"
                            onClick={() => onItemClick(id)}
                          />
                        </>
                      )}
                    </div>
                    {(itemsToShow.length > 0 || showAllItems) && (
                      <CCollapse show={itemsToShow.includes(id) || showAllItems}>
                        {renderTags({ id, ...rest })}
                      </CCollapse>
                    )}
                  </Fragment>
                );
              })}
            </>
          ) : (
            <LoadingAnimation uiLoader />
          )}
        </div>
      </CCollapse>
    </>
  );
});
